import { render, staticRenderFns } from "./InvoicePdf.vue?vue&type=template&id=381e337d&scoped=true&"
import script from "./InvoicePdf.vue?vue&type=script&lang=js&"
export * from "./InvoicePdf.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePdf.vue?vue&type=style&index=0&id=381e337d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381e337d",
  null
  
)

export default component.exports